import React, { createContext, useContext } from 'react';

const Context = createContext();

export const ActiveToggleProvider = ({ config, children }) => {
  return <Context.Provider value={config}>{children}</Context.Provider>;
};

export const useActiveToggleConfig = () => useContext(Context);
